import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

const LOCAL_DOMAINS = ['localhost', '127.0.0.1', 'dev.app.demand-iq.com'];

// Use a build-time hash injected by Vite so locale files are cached properly
// across sessions. Falls back to empty string (no cache-busting) when unset.
const HASH = import.meta.env.VITE_BUILD_HASH ?? '';

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: LOCAL_DOMAINS.includes(window.location.hostname),
    keySeparator: false,
    fallbackLng: {
      'en-US': ['en'],
      default: ['en'],
    },
    ns: [
      'common',
      'canonry',
      'company',
      'dashboards',
      'integrations',
      'journey-template',
      'journeys',
      'locations',
      'members',
      'mia-google-ai-search',
      'no-auth',
      'organization',
      'plans',
      'presentations',
      'product',
      'product-analytics',
      'prospects',
      'settings',
      'teams',
      'templates',
      'webhooks',
      'workflow-dashboard',
    ],
    defaultNS: 'common',
    fallbackNS: 'common',
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${HASH}`,
    },
  });
